import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import axios from '@vtblife/axios';
import { cmsDataUrlByEnvironmentMap } from '@vtblife/block-kit-utils';
export var getQuizProps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var id, _ref$environment, environment, _yield$axios$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _ref.id, _ref$environment = _ref.environment, environment = _ref$environment === void 0 ? 'production' : _ref$environment;
          if (id) {
            _context.next = 3;
            break;
          }
          throw new Error('id обязателен');
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return axios.get("".concat(cmsDataUrlByEnvironmentMap[environment], "/json/quiz/").concat(id, ".json"));
        case 6:
          _yield$axios$get = _context.sent;
          data = _yield$axios$get.data;
          return _context.abrupt("return", data.props);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](3);
          console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043A\u0432\u0438\u0437\u0430 \u0441 id: ".concat(id), _context.t0);
          throw _context.t0;
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 11]]);
  }));
  return function getQuizProps(_x) {
    return _ref2.apply(this, arguments);
  };
}();